import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { finalize, Subject } from 'rxjs';
import {
  City,
  DataWhatsAppMessageOtpRequest,
  PhoneCountryCode,
  Platform,
  WaysFindOut
} from 'src/app/shared/interfaces/data-selects';
import { StepInitResponse, StepWelcomeLto } from 'src/app/shared/interfaces/step-data';
import { PrivacyTermsComponent } from 'src/app/shared/privacy-terms/privacy-terms.component';
import { RequestInformationComponent } from 'src/app/shared/request-information/request-information.component';
import { GetDataService } from 'src/app/shared/services/get-data.service';
import { GtmService } from 'src/app/shared/services/gtm.service';
import { PostDataService } from 'src/app/shared/services/post-data.service';
import { RequestFormService } from 'src/app/shared/services/request-form.service';
import { UrlPlatformService } from 'src/app/shared/services/url-platform.service';
import { AutoUnsubscribeComponent } from 'src/app/shared/utils/auto-unsubscribe.component';
import { FormsValidators } from 'src/app/shared/utils/forms-validators';

@Component({
  selector: 'app-step-bienvenida-lto-nuevo',
  templateUrl: './step-bienvenida-lto-nuevo.component.html',
  styleUrls: ['./step-bienvenida-lto-nuevo.component.scss'],
})
export class StepBienvenidaLtoNuevoComponent extends AutoUnsubscribeComponent implements OnInit {
  @ViewChildren('codeInputs') codeInputs!: QueryList<ElementRef>;

  @Input() whereFindOutId: string | undefined = '';

  @Output() success = new EventEmitter<string>();

  public formStepBienvenidaLto!: FormGroup;
  public requestNumber = '';
  protected _onDestroy = new Subject<void>();
  public emailCtrl: FormControl = new FormControl('');
  public country: string | undefined;
  public phoneCountryCode: PhoneCountryCode[] = [];
  public platformList: Platform[] = [];
  public emailPromoter: any = '';
  public workingCities: City[] = [];

  public city: string = '';
  public referall: string = '';
  public referralCode!: string;
  public vehicleType: string = '';
  public referallId: string = '';
  public vehicleFinancingId?: string;
  public workPlatformId?: string;
  public promoter?: string;
  public debugWhereFindOutId?: string;
  public wayFindOutName = '';
  public referrer: string = '';

  public creditType!: string;

  public isWaitingApi = false;
  public isFormValid = false;
  public campaign!: string;

  requestMode: 0 | 1 = 1; // 0 = Normal and 1 = NIP.
  whatsAppCodeSent = false;
  codeVerified = false;
  formId = '';
  whatsAppCodeFg!: FormGroup;
  totalAttempts = 0;
  MAX_WHATSAPP_ATTEMPTS = 3;
  showBuroTerms = false;
  platformName = '';

  campaignsWithExternalNumberAllowed: string[] = ['cd07107a-b988-43e3-b570-d2b7810b93e0'];

  constructor(
    private frmBuilder: FormBuilder,
    private postDataService: PostDataService,
    private dialog: MatDialog,
    private requestFormService: RequestFormService,
    private activatedRouter: ActivatedRoute,
    private urlPlatformService: UrlPlatformService,
    private getDataService: GetDataService,
    private gtmService: GtmService
  ) {
    super();

    this.activatedRouter.queryParams.subscribe((params) => {
      this.requestNumber = params['requestNumber'];
      this.city = params['city'];
      this.referall = params['referall'];
      this.referralCode = params['referralCode'];
      this.vehicleType = params['vehicleType'];
      this.referallId = params['referallId'];
      this.creditType = params['creditType'];
      this.debugWhereFindOutId = params['whereFindOutId'];
      this.vehicleFinancingId = params['vehicleFinancingId'];
      this.workPlatformId = params['workPlatformId'];
      this.promoter = params['promoter'];
      this.campaign = params['campaign'];
      this.referrer = params['referrer'];
    });

    this.emailPromoter =
      this.activatedRouter.snapshot.queryParams['emailPromoter'];
  }

  ngOnInit(): void {
    // this.requestMode = this.selectRandomMode();
    this.requestMode = this.promoter || this.referrerPage ? 0 : 1;
    this.isWaitingApi = false;
    const EMAIL = /^[\w-.!#$%&'*+-/=?^_`{|}~]+@([\w-]+\.)+[\w-]{2,6}$/;
    const MOBILE = /^[0-9]{10}$/;

    this.sendInitialIntent();
    this.initWhatsAppCodeForm();

    this.formStepBienvenidaLto = this.frmBuilder.group({
      firstName: ['', [Validators.required, Validators.maxLength(45), Validators.minLength(2)]],
      lastName: ['', [Validators.required, Validators.maxLength(45), Validators.minLength(2)]],
      cellPhoneCountryCode: ['', [Validators.required]],
      mobilePhoneNumber: ['', [Validators.required, Validators.pattern(MOBILE)]],
      referrerCellPhoneCountryCode: ['MX', [Validators.required]],
      referrerMobilePhoneNumber: ['', [Validators.pattern(MOBILE)]],
      privacyNoticeAccepted: ['', [Validators.requiredTrue]],
      buroRequestAccepted: ['', [Validators.requiredTrue]],
      platformId: ['', [Validators.required]],
      workCityId: ['', [Validators.required]]
    });

    this.emailCtrl.setValidators([
      Validators.required,
      Validators.pattern(EMAIL),
      FormsValidators.validateEmailEnd(),
    ]);

    this.getDataService.getApplicationsSelectsLto('mx').subscribe((resp) => {
      this.platformList = resp.platforms;
      this.phoneCountryCode = resp.phoneCountryCode;

      this.workingCities = resp.cities
        .filter((city) => city.code != 'Especifique')
        .sort((a, b) => a.name.localeCompare(b.name));

      const jobCityOther = resp.cities.find(
        (c) => c.code === 'Especifique'
      );
      if (jobCityOther) {
        this.workingCities.push(jobCityOther);
      }

      const workingCity = this.workingCities.find(
        (city) => city.id == this.city
      );
      if (workingCity) {
        this.formStepBienvenidaLto.controls['workCityId'].setValue(workingCity.id);
        this.formStepBienvenidaLto.controls['workCityId'].disable();
      }

      const phoneCode = resp.phoneCountryCode.find(
        (op) => op.countryCode == 'MX'
      );
      if (phoneCode) {
        this.formStepBienvenidaLto.controls['cellPhoneCountryCode'].setValue(
          phoneCode.countryCode
        );
      }

      if (!this.whereFindOutId) this.whereFindOutId = this.referallId;
      const wayToFindOut = resp.waysFindOut.find(way => way.id == this.whereFindOutId);
      if (!wayToFindOut) {
        this.whereFindOutId = undefined;
      }

      const vehicleFinancing = resp.vehicleFinancingId.find(veh => veh.id == this.vehicleFinancingId);
      if (!vehicleFinancing) {
        this.vehicleFinancingId = undefined;
      }

      const workPlatform = resp.platforms.find(p => p.id == this.workPlatformId);
      if (workPlatform) {
        this.formStepBienvenidaLto.controls['platformId'].setValue(workPlatform.id);
        this.formStepBienvenidaLto.controls['platformId'].disable();
      }
    });

    this.formStepBienvenidaLto.statusChanges.subscribe(status => {
      this.isFormValid = status === 'VALID';
    });
    this.applyConditionalValidators();
    this.getCompleteData('mx');
  }

  getCompleteData(value: string) {
    let waysFindOut: WaysFindOut[] = [];
    this.getDataService.getApplicationsSelectsLto(value).subscribe((resp) => {
      if (resp.waysFindOut && resp.waysFindOut.length > 0) {
        waysFindOut = resp.waysFindOut;
        this.wayFindOutName = waysFindOut.find(way => way.id === this.whereFindOutId)?.name || '';
      }
    });
  }

  selectRandomMode(): 0 | 1 {
    // Both should have a probability of 50%.
    return Math.random() < 0.5 ? 0 : 1;
  }

  private applyConditionalValidators(): void {
    const isReferrerPage = this.referrerPage; // true => require referrer fields.
    const MOBILE = /^[0-9]{10}$/;

    const mobilePhoneCtrl = this.formStepBienvenidaLto.get('mobilePhoneNumber')!;
    const buroCtrl       = this.formStepBienvenidaLto.get('buroRequestAccepted')!;
    const refMobileCtrl  = this.formStepBienvenidaLto.get('referrerMobilePhoneNumber')!;
    const refCountryCtrl = this.formStepBienvenidaLto.get('referrerCellPhoneCountryCode')!;

    // mobilePhoneNumber: required only if !referrerPage.
    mobilePhoneCtrl.setValidators(
      isReferrerPage ? [Validators.pattern(MOBILE)] : [Validators.required, Validators.pattern(MOBILE)]
    );
    mobilePhoneCtrl.updateValueAndValidity({ emitEvent: false });

    // buroRequestAccepted: requiredTrue only if !referrerPage.
    if (isReferrerPage) {
      buroCtrl.clearValidators();
    } else {
      buroCtrl.setValidators([Validators.requiredTrue]);
    }
    buroCtrl.updateValueAndValidity({ emitEvent: false });

    // Referrer fields: required only if referrerPage.
    refMobileCtrl.setValidators(
      isReferrerPage ? [Validators.required, Validators.pattern(MOBILE)] : [Validators.pattern(MOBILE)]
    );
    refMobileCtrl.updateValueAndValidity({ emitEvent: false });

    refCountryCtrl.setValidators(isReferrerPage ? [Validators.required] : []);
    refCountryCtrl.updateValueAndValidity({ emitEvent: false });
  }


  sendWhatsappCode(resend: boolean = false): void {
    const data: DataWhatsAppMessageOtpRequest = {
      formId: this.formId,
      phoneNumber: this.formStepBienvenidaLto.get('mobilePhoneNumber')?.value,
      phoneCountryCode: this.formStepBienvenidaLto.get('cellPhoneCountryCode')?.value === 'MX' ? '+52' : '+57',
    }

    this.isWaitingApi = true;
    this.postDataService.sendWhatsappCode(data)
      .pipe(finalize(() => this.isWaitingApi = false))
      .subscribe({
        next: () => {
          this.whatsAppCodeSent = true;
          if (resend) {
            // Reset the verification code inputs.
            this.codeInputs.forEach(input => input.nativeElement.value = '');
          } else {
            this.totalAttempts = 0; // Restart the attempts when resending the code.
          }
          // Push GTM event for login.
          this.gtmService.pushLoginEvent();
        },
        error: (err) => {
          console.log('Error al enviar código de WhatsApp', err);
        },
      });
  }


  sendInitialIntent(): void {
    this.postDataService.sendInitialIntent(this.requestMode).subscribe({
      next: (resp) => {
        this.formId = resp.formId;
      },
      error: (err) => {
        console.error('Error al enviar intento inicial', err);
      },
    });
  }

  getNow(): Date {
    return new Date();
  }

  whatsappCodeVerified(): void {
    this.whatsAppCodeSent = false;
    this.codeVerified = true;
  }

  initWhatsAppCodeForm(): void {
    this.whatsAppCodeFg = this.frmBuilder.group({
      code: [''],
    });
  }

  isCodeComplete(): boolean {
    return this.codeInputs?.toArray().every(input => input.nativeElement.value.length === 1);
  }

  generateCode(): string {
    return this.codeInputs?.toArray().map(input => input.nativeElement.value).join('');
  }

  onFocus(index: number): void {
    const input = this.codeInputs.get(index)?.nativeElement;
    if (input) {
      input.select();
    }
  }

  onInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if (!/^\d$/.test(value)) {
      input.value = '';
      return;
    }

    if (index < this.codeInputs.length - 1) {
      this.codeInputs.get(index + 1)?.nativeElement.focus();
    }
  }

  onKeyDown(event: KeyboardEvent, index: number): void {
    const input = event.target as HTMLInputElement;

    if (event.key === 'Backspace' && !input.value && index > 0) {
      this.codeInputs.get(index - 1)?.nativeElement.focus();
    }
  }

  getStepWelcomeObject(): StepWelcomeLto {
    let referrerToSend: string | null = null;
    if (this.whereFindOutId && this.campaignsWithExternalNumberAllowed.includes(this.whereFindOutId)) {
      referrerToSend = `${this.formStepBienvenidaLto.get('referrerCellPhoneCountryCode')?.value === 'MX' ? '+52' : '+57'}${this.formStepBienvenidaLto.get('referrerMobilePhoneNumber')?.value}`;
    } else if (this.referrer) {
      referrerToSend = this.referrer;
    }

    return {
      ...this.formStepBienvenidaLto.value,
      mobilePhoneNumber:
        this.requestFormService.getDataForm().requestNumber ||
          this.requestNumber
          ? ''
          : this.formStepBienvenidaLto.get('mobilePhoneNumber')?.value,
      email:
        this.requestFormService.getDataForm().requestNumber ||
          this.requestNumber
          ? ''
          : this.emailCtrl.value,
      promoterEmail: this.emailPromoter ? this.emailPromoter : null,
      platformId: this.formStepBienvenidaLto.get('platformId')?.value,
      workCityId: this.city ? this.city : this.formStepBienvenidaLto.get('workCityId')?.value,
      whereFindOutId: this.whereFindOutId,
      campaign: this.campaign,
      vehicleFinancingId: this.vehicleFinancingId,
      cellPhoneCountryCode: this.formStepBienvenidaLto.get('cellPhoneCountryCode')?.value,
      promoter: this.promoter,
      debugWhereFindOutId: this.debugWhereFindOutId,
      formId: this.formId,
      otpCode: this.requestMode === 1 ? this.generateCode() : null,
      referrer: referrerToSend,
    };
  }

  reloadPage() {
    window.location.reload();
  }

  saveStepWelcome(changeToNextStep = true) {
    this.applyConditionalValidators();
    if (!this.formStepBienvenidaLto.valid && this.emailCtrl.invalid) {
      FormsValidators.markFormGroupTouched(this.formStepBienvenidaLto);
      return;
    }

    this.isWaitingApi = true;
    const postSaveDataWelcomeLto$ = this.postDataService
      .postSaveDataBienvenidaLto('MX', this.getStepWelcomeObject())
      .pipe()
      .subscribe({
        next: (resp) => {
          this.requestNumber = resp.requestNumber;
          sessionStorage.setItem('requestNumber', this.requestNumber);
          sessionStorage.setItem('email', this.emailCtrl.value);
          sessionStorage.setItem('applicationId', resp.id);

          const dataPlatform = {
            platform: resp.platformName,
            url: resp.loginUrl
          };
          this.urlPlatformService.setDataUrlPlatform(dataPlatform);

          this.emailCtrl.disable();
          const assignedToIAAgent: boolean = resp.assignedToIAAgent ?? false;
          this.formStepBienvenidaLto.controls['mobilePhoneNumber'].disable();
          this.formStepBienvenidaLto.controls['cellPhoneCountryCode'].disable();
          // Flow with referrer.
          if (this.referrerPage) {
            // Parent component decides what to do after success.
            this.success.emit('referrer');
            return;
          }
          // Flow with IA agent assignment.
          if (assignedToIAAgent) {
            // IA agent will handle it, keep the current page/
            this.success.emit('iaAgent');
          } else {
            // No IA agent: redirect to login page.
            window.open(`${resp.loginUrl}`, '_self');
          }
        },
        error: (err) => {
          if (err.error.errors[0].message.includes('Invalid NIP code')) {
            if (this.totalAttempts < this.MAX_WHATSAPP_ATTEMPTS) {
              this.totalAttempts++;
              this.whatsAppCodeSent = true; // Keep showing the code field.
            }
            if (changeToNextStep) {
              this.openRequestInformationDialog(err, undefined, 'NIP');
            }
          } else {
            if (changeToNextStep) {
              this.openRequestInformationDialog(err);
            }
          }

          this.isWaitingApi = false;
        }
      });

    this.subscriptions.push(postSaveDataWelcomeLto$);
  }

  openRequestInformationDialog(
    error?: HttpErrorResponse,
    event?: StepInitResponse,
    extraInfo?: string
  ) {
    this.requestFormService.setDataPromoterLTO(event?.promoter!);
    let errorMessage = 'Ha ocurrido un error.';

    const errorValidationError = `ValidationError`.match(
      error?.error.errors[0].code
    );

    const errorCodeEmailInUse = `EMAIL_IN_USE`.match(
      error?.error.errors[0].code
    );

    const errorCodePhoneRepeat = `PPHONE_IN_USE`.match(
      error?.error.errors[0].code
    );

    const errorEmailFormat = `Email must be a valid email address`.match(
      error?.error.errors[0].message
    );

    if (errorCodeEmailInUse) {
      errorMessage = `Ya ha sido registrada una solicitud con el correo electrónico que nos proporcionaste.\n
      Si desea retomar una solicitud, puede hacerlo desde la sección de BUSCAR SOLICITUD con su correo electrónico y número de solicitud.`;
      this.phoneOrEmailDuplicatedRequest();
    }

    if (errorCodePhoneRepeat) {
      errorMessage = `Ya ha sido registrada una solicitud con el teléfono celular que nos proporcionaste.
      \nSi desea retomar una solicitud, puede hacerlo desde la sección de BUSCAR SOLICITUD con su correo electrónico y número de solicitud.`;
      this.phoneOrEmailDuplicatedRequest();
    }

    if (errorValidationError && errorEmailFormat) {
      errorMessage = `Ingrese un formato de email correcto.`;
    }

    if (extraInfo === 'NIP') {
      errorMessage = `El código de WhatsApp es incorrecto. Por favor, intenta de nuevo.`;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Información de solicitud',
      question: errorMessage,
    };
    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
  }

  phoneOrEmailDuplicatedRequest(): void {
    const platformName = this.platformList.find(p => p.id === this.formStepBienvenidaLto.get('platformId')?.value)?.name || '';
    const workCityName = this.workingCities.find(c => c.id === this.formStepBienvenidaLto.get('workCityId')?.value)?.name || '';
    const extraData = {
      platformName,
      workCityName,
      whereFindOutName: this.wayFindOutName
    };
    this.postDataService.sendDuplicatedPhoneOrEmailTeamsNotification('MX', this.getStepWelcomeObject(), extraData).subscribe({
      error: (err) => {
        console.error('Error sending duplicated phone/email notification', err);
      }
    });
  }

  isLetter(evt: KeyboardEvent) {
    if (
      evt.code != 'Space' &&
      evt.code != 'Backspace' &&
      evt.code != 'Delete' &&
      evt.code != 'ArrowLeft' &&
      evt.code != 'ArrowRight' &&
      evt.code != 'Tab' &&
      (evt.keyCode < 65 || (evt.keyCode > 90 && evt.keyCode != 192))
    )
      evt.preventDefault();
  }

  openNoticeOfPrivacyDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = '90vh';
    const dialogSubscription$ = this.dialog
      .open(PrivacyTermsComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
    this.subscriptions.push(dialogSubscription$);
  }

  deleteSpaceInit(evt: KeyboardEvent) {
    evt.target?.addEventListener('keyup', (e: any) => {
      const string = e.target!.value;
      e.target.value = string.trimStart();
    });
  }

  getCountry() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('language')!
      : this.requestFormService.getUpdateForm().countryCode.code.toLowerCase();
  }

  getApplicationId() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('applicationId')!
      : this.requestFormService.getUpdateForm().id;
  }

  get referrerPage(): boolean {
    return !!this.whereFindOutId && this.campaignsWithExternalNumberAllowed.includes(this.whereFindOutId);
  }
}
